import { DEVICE_HIBERNATING, DEVICE_ONLINE } from "constant/device-status";
import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as DS from "redux-store/device-statuses/selectors";
import { DeviceLocalTimeBox } from "ui/device-stats/device-local-time-box";
import { InfoBox } from "ui/info-box";
import { timeSince, utcToLocal } from "util/time";
import { VIEW } from "view/views";

const ColorScheme = {
  CONNECTIVITY: "aqua",
  LOCAL_TIME: "light-blue",
  OFFLINE: "gray",
  STRATEGY: "teal",
};

class StatusBox extends React.PureComponent {
  static get propTypes() {
    return {
      device: PropTypes.object.isRequired,
      deviceStatus: PropTypes.object.isRequired,
      deviceStatusOnline: PropTypes.bool,
      stats: PropTypes.object.isRequired,
    };
  }

  render() {
    const { device, deviceStatusOnline, stats } = this.props;
    const deviceStatus = DS.getStatus(this.props.deviceStatus);
    const hibernating = deviceStatus === DEVICE_HIBERNATING;
    const hibernatingTitle = hibernating ? "(hibernating)" : "";
    const statusTitle = `Player status ${hibernatingTitle}`;

    const offlineClass = deviceStatusOnline === false ? "offline" : "";

    return (
      <Row className="device-status-box">
        <Col xs={12} md={6} lg={3}>
          <InfoBox
            title={statusTitle}
            className={`online-component ${offlineClass}`}
            icon={deviceStatus.iconClass.replace("fa-", "")}
            color={deviceStatus.color}
            subText={this._statusSubText()}
            desc={this._statusDesc(deviceStatus)}
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <InfoBox
            title="Connectivity"
            icon="wifi"
            color={this._connectivityColor(deviceStatus)}
            subText="Network connectivity (24h)"
            desc={this._connectivityUptime()}
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <InfoBox
            title={this._formatStrategyTitle()}
            icon="object-ungroup"
            color={this._strategyColor(deviceStatus)}
            subText={this._strategyStartTime(deviceStatus)}
            desc={this._formatStrategyName(deviceStatus)}
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <DeviceLocalTimeBox
            color={this._timeColor(deviceStatus)}
            device={device}
            stats={stats}
          />
        </Col>
      </Row>
    );
  }

  _formatStrategyTitle() {
    const { stats } = this.props;
    const id = get(stats, "strategy.id", null);
    let title = "STRATEGY";

    if (id) {
      title = (
        <div>
          STRATEGY (
          <Link
            className="device-status-link-to-strategy"
            to={`/v2/strategies/${id}/${VIEW.EDIT}`}
          >
            CLICK TO VIEW
          </Link>
          )
        </div>
      );
    }

    return title;
  }

  _formatStrategyName(deviceStatus) {
    const { stats } = this.props;
    const name = get(stats, "strategy.name", "");
    const hibernating = deviceStatus === DEVICE_HIBERNATING;

    if (hibernating) {
      return "Hibernating";
    }

    return name || "N/A";
  }

  _strategyStartTime(deviceStatus) {
    const { stats } = this.props;
    const startTime = get(stats, "strategy.startTime", null);
    const hibernating = deviceStatus === DEVICE_HIBERNATING;

    if (hibernating) {
      return " ";
    }

    if (startTime) {
      return `Running for ${timeSince(startTime)}`;
    }

    return "N/A";
  }

  _strategyColor(deviceStatus) {
    return deviceStatus === DEVICE_ONLINE
      ? ColorScheme.STRATEGY
      : ColorScheme.OFFLINE;
  }

  _timeColor(deviceStatus) {
    return deviceStatus === DEVICE_ONLINE
      ? ColorScheme.LOCAL_TIME
      : ColorScheme.OFFLINE;
  }

  _connectivityUptime() {
    const uptime = get(this.props.stats, "stats.network_uptime", null);

    return uptime ? `${uptime.toFixed(2)}%` : "N/A";
  }

  _connectivityColor(deviceStatus) {
    return deviceStatus === DEVICE_ONLINE
      ? ColorScheme.CONNECTIVITY
      : ColorScheme.OFFLINE;
  }

  _statusDesc(deviceStatus) {
    const startTime = this._getPlayerStartTime();

    return startTime ? `Uptime: ${timeSince(startTime)}` : deviceStatus.label;
  }

  _statusSubText() {
    const startTime = this._getPlayerStartTime();

    return startTime ? `Started on ${utcToLocal(startTime)}` : "";
  }

  _getPlayerStartTime() {
    return get(this.props.stats, "player.startTime", null);
  }
}

export { StatusBox };
